import { resource, RequestConfig } from '../helper/resource';

/**
 * 资管新流程-人脸识别
 */
export function zgServer_addAuthFaceUsingPOST(
  req: ZgServer.AddFaceTokenParam | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/client/addAuthFaceNew', req, config);
}

/**
 * 机构客户获取授权人名单
 */
export function zgServer_AthorizerUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListAthorizer> {
  return resource.post('/zg/client/athorizer', req, config);
}

/**
 * 客户已购买的产品号
 */
export function zgServer_getBoughtProdUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListstring> {
  return resource.post('/zg/client/boughtProd', req, config);
}

/**
 * 备用方案-是否启用备用方案true启用false禁用
 */
export function zgServer_cardSwitchUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.ApiResultboolean> {
  return resource.post('/zg/client/cardSwitch', req, config);
}

/**
 * 获取客户合同
 */
export function zgServer_contractUsingPOST(
  req: ZgServer.ClientContract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgClientContract> {
  return resource.post('/zg/client/contract', req, config);
}

/**
 * 创建个人客户签章
 */
export function zgServer_createPersonSealUsingPOST(
  req: ZgServer.Seal | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultJSONObject> {
  return resource.post('/zg/client/creatSeal', req, config);
}

/**
 * 获取鉴权流水号
 */
export function zgServer_getAuthSerialNoUsingPOST(
  req: ZgServer.Athorizer | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/client/getAuthSerialNo', req, config);
}

/**
 * 备用方案-查询客户身份证
 */
export function zgServer_getIDCardUsingPOST(
  req: ZgServer.ClientIdParam | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgClientIdCard> {
  return resource.post('/zg/client/getIDCard', req, config);
}

/**
 * 获取客户待签署合同列表的状态
 */
export function zgServer_getSignedStateUsingPOST(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListZgClientContract> {
  return resource.post('/zg/client/getSignedState', req, config);
}

/**
 * 获取人脸识别结果
 */
export function zgServer_identifiedResultUsingPOST(
  req: ZgServer.EncodeToken | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultboolean> {
  return resource.post('/zg/client/identifiedResult', req, config);
}

/**
 * 查询客户是否第一次购买
 */
export function zgServer_isFirstUsingPOST(
  req: ZgServer.Account | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultSignInfo> {
  return resource.post('/zg/client/isFirst', req, config);
}

/**
 * 初始化协议状态
 */
export function zgServer_isFirstNewUsingPOST(
  req: ZgServer.Account | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultSignInfo> {
  return resource.post('/zg/client/isFirstNew', req, config);
}

/**
 * 个人购买权限校验
 */
export function zgServer_checkPersonPermissionUsingPOST_1(
  req: ZgServer.Production | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/client/permission', req, config);
}

/**
 * 获取产品详情-新
 */
export function zgServer_getProductInfoUsingPOST(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListZgProduction> {
  return resource.post('/zg/client/productInfo', req, config);
}

/**
 * 获取产品详情
 */
export function zgServer_getProductionUsingPOST(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgProduction> {
  return resource.post('/zg/client/production', req, config);
}

/**
 * 获取产品详情-contract
 */
export function zgServer_getProductionNewUsingPOST(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgProduction> {
  return resource.post('/zg/client/productionNew', req, config);
}

/**
 * 查询客户是否回访
 */
export function zgServer_getRevisitUsingPOST(
  req: ZgServer.Allotno | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgRevisit> {
  return resource.post('/zg/client/queryRevisit', req, config);
}

/**
 * 注册Token
 */
export function zgServer_registerUsingPOST(
  req: ZgServer.Identification | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListstring> {
  return resource.post('/zg/client/register', req, config);
}

/**
 * 客户回访
 */
export function zgServer_revisitUsingPOST(
  req: ZgServer.ZgRevisit | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/client/revisit', req, config);
}

/**
 * 获取客户签章
 */
export function zgServer_getSealUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.ApiResultJSONObject> {
  return resource.post('/zg/client/seal', req, config);
}

/**
 * 获取客户待签署合同列表
 */
export function zgServer_signedListUsingPOST(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListZgClientContract> {
  return resource.post('/zg/client/signedList', req, config);
}

/**
 * 获取客户待签署合同列表(电子合同专用)
 */
export function zgServer_signedListContractUsingPOST(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListZgClientContract> {
  return resource.post('/zg/client/signedListContract', req, config);
}

/**
 * 获取Token
 */
export function zgServer_getTokenUsingPOST(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultFlowNoAndToken> {
  return resource.post('/zg/client/token', req, config);
}

/**
 * 查询客户所有的委托
 */
export function zgServer_getRevisitUsingPOST_1(
  req: void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListZgPurchaseRecord> {
  return resource.post('/zg/client/unRevisit', req, config);
}

/**
 * 备用方案-用户上传身份证
 */
export function zgServer_uploadIDCardUsingPOST(
  req: FormData,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgClientIdCard> {
  return resource.postForm('/zg/client/uploadIDCard', req, config);
}

/**
 * 是否合格资管投资者
 */
export function zgServer_isVerifiedUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/client/verified', req, config);
}

/**
 * 记录双录成功的客户
 */
export function zgServer_videoOkUsingPOST(req: ZgServer.VideoClientDto | void, config?: RequestConfig): Promise<void> {
  return resource.post('/zg/client/videoOk', req, config);
}

/**
 * 双录是否有效
 */
export function zgServer_hasVideoRecordUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/client/videoRecord', req, config);
}

/**
 * 个人购买资管-客户是否需要双录
 */
export function zgServer_doubleRecordingUsingPOST(
  req: ZgServer.ClientRecord | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultboolean> {
  return resource.post('/zg/clientNew/doubleRecording', req, config);
}

/**
 * 机构客户批量签署
 */
export function zgServer_batchInstituteSignUsingPOST(
  req: ZgServer.BatchContract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/batchInstituteSign', req, config);
}

/**
 * 个人客户批量签署
 */
export function zgServer_batchSignUsingPOST(
  req: ZgServer.BatchContract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/batchSign', req, config);
}

/**
 * 获取条款
 */
export function zgServer_getClauseUsingPOST_1(
  req: ZgServer.Contract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListZgContractClause> {
  return resource.post('/zg/contract/clause', req, config);
}

/**
 * 资管新流程-查询客户是否勾选过投资者声明
 */
export function zgServer_getClauseUsingPOST(
  req: ZgServer.ClientClauseDto | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListZgClientClause> {
  return resource.post('/zg/contract/getClause', req, config);
}

/**
 * 查询风险揭示书代销机构版
 */
export function zgServer_getRiskDXUsingPOST_1(
  req: ZgServer.ProducCode | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgClientContract> {
  return resource.post('/zg/contract/getRiskDX', req, config);
}

/**
 * 查询风险揭示书代销机构版签署状态
 */
export function zgServer_getRiskDXSignUsingPOST_1(
  req: ZgServer.DxSignId | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultZgClientContract> {
  return resource.post('/zg/contract/getRiskDXSign', req, config);
}

/**
 * 机构客户预览产品合同
 */
export function zgServer_instituteContractPreviewUsingPOST(
  req: ZgServer.InstituteContract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultContractPreview> {
  return resource.post('/zg/contract/institutePreview', req, config);
}

/**
 * 机构客户签署
 */
export function zgServer_instituteSignUsingPOST(
  req: ZgServer.Contract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/instituteSign', req, config);
}

/**
 * 机构客户createSeal
 */
export function zgServer_institutecreateSealUsingPOST(
  req: ZgServer.InstituteContract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResult> {
  return resource.post('/zg/contract/institutecreateSeal', req, config);
}

/**
 * 获取产品合同
 */
export function zgServer_getContractListUsingPOST(
  req: ZgServer.Production | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultListstring> {
  return resource.post('/zg/contract/list', req, config);
}

/**
 * 个人客户预览产品合同
 */
export function zgServer_contractPreviewUsingPOST(
  req: ZgServer.Contract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultContractPreview> {
  return resource.post('/zg/contract/preview', req, config);
}

/**
 * 阅读留痕
 */
export function zgServer_readSaveUsingPOST(
  req: ZgServer.ReadLeave | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/readSave', req, config);
}

/**
 * 个人客户签署
 */
export function zgServer_signUsingPOST(
  req: ZgServer.Contract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/sign', req, config);
}

/**
 * 查询产品适当性参数
 */
export function zgServer_isSuitableUsingPOST(
  req: ZgServer.Production | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/suitability', req, config);
}

/**
 * getSeals
 */
export function zgServer_getSealsUsingPOST(
  req: ZgServer.Contract | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/test', req, config);
}

/**
 * 条款留痕
 */
export function zgServer_confirmClauseUsingPOST(
  req: ZgServer.Clause | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/contract/updateClause', req, config);
}

/**
 * 机构购买权限校验
 */
export function zgServer_checkInstitutePermissionUsingPOST(
  req: ZgServer.Production | void,
  config?: RequestConfig
): Promise<ZgServer.ApiResultstring> {
  return resource.post('/zg/institute/permission', req, config);
}
